import { FC, useState } from 'react';
import { confirmResetPassword, resetPassword } from 'aws-amplify/auth';
import '../login/login-page.css';
import { Navigate } from 'react-router-dom';
import { RoutePaths } from '../../routes/main-routes';
import {
  ForgotPasswordForm,
  ForgotPasswordFormFields,
} from '../../components/login/forgot-password-form';
import {
  ForgotPasswordConfirmForm,
  ForgotPasswordConfirmFormFields,
} from '../../components/login/forgot-password-confirm-form';

export type LoginUserDetails = {
  step: string;
  username: string;
};

export const ForgotPasswordPage: FC = () => {
  const [loginDetails, setLoginDetails] = useState<LoginUserDetails>({
    step: 'START',
    username: '',
  });

  const onSubmit = async (data: ForgotPasswordFormFields) => {
    try {
      const { nextStep } = await resetPassword(data);
      const updatedLoginDetails = {
        ...loginDetails,
        step: nextStep.resetPasswordStep,
        username: data.username,
      };
      setLoginDetails(updatedLoginDetails);
    } catch (error) {
      console.error('Error resetting password', error);
    }
  };

  const onConfirmSubmit = async (data: ForgotPasswordConfirmFormFields) => {
    try {
      await confirmResetPassword({
        username: loginDetails.username,
        newPassword: data.newPassword,
        confirmationCode: data.confirmationCode.toString(),
      });
      window.location.href = '/login';
    } catch (error) {
      console.error('Error confirming password reset', error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-logo philips-shield"></div>
      <div className="login-header">Forgot Password</div>
      {loginDetails.step === 'START' && <ForgotPasswordForm onSubmit={onSubmit} />}
      {loginDetails.step === 'CONFIRM_RESET_PASSWORD_WITH_CODE' && (
        <ForgotPasswordConfirmForm onSubmit={onConfirmSubmit} />
      )}
      {loginDetails.step === 'DONE' && <Navigate to={`/${RoutePaths.Studies}`} replace={true} />}
    </div>
  );
};
